/**
 * @file Keep all host names in one place.
 */
export const INHOUSE_HOST = 'v1.padlet.pics'
export const PROXY_HOST = 'padlet.pics'
export const GOOGLE_HOST = 'g4.padlet.pics'
export const BUNNY_GOOGLE_PROXY_HOST = 'g4.padlet.pics'
// current and former inhouse hosts
export const INHOUSE_HOST_LIST = [INHOUSE_HOST, 'padlet.pics', 'imgglb.padletcdn.com']
